import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Button, DialogActions, DialogContent, DialogContentText, IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import { TooltipCC } from 'components/common';
import { useTranslation } from 'react-i18next';
import { setCloseDialogCC } from 'utils/helpers';
import DialogBaseCC from './DialogBaseCC';
import { DIALOG_ID } from './constant';
import { IconClose } from 'assets/icons';

const DialogEvent = () => {
    const propsDialog = useLegacyDialogProps();
    const { onCancel, img, lableButton } = propsDialog
    const { t } = useTranslation()

    const handleCancel = () => {
        setCloseDialogCC()
        if (onCancel) onCancel()
    }

    const backgroundStyle = {
        backgroundImage : `url(${img})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    }

    return (
        <DialogBaseCC id={DIALOG_ID.EVENT} hiddenTitle= {true} styleCC={backgroundStyle}>
            <Box sx={backgroundStyle}>
                <DialogContent sx={{width: '800px !important', maxWidth: 'unset !important', height: '500px', padding: '0 !important'}}>
                    <DialogContentText>
                    <TooltipCC title={t('dialog.close')}>
                        <IconButton sx={{ position: 'absolute', right:0, top:0, margin: '10px' }} aria-label="close" onClick={handleCancel}>
                            <IconClose />
                        </IconButton>
                    </TooltipCC>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: "flex" , textAlign: 'center', justifyContent: 'center', padding:' 25px 10px !important'}}>
                    <Button variant='contained' onClick={handleCancel}>{lableButton}</Button>
                </DialogActions>
            </Box>
        </DialogBaseCC>
    )
}

export default DialogEvent